import { useEffect, useMemo, useState, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { Select, Row, Col, Statistic, Button, Space, Table } from 'antd'
import { RedoOutlined } from '@ant-design/icons'
import { baseAxiosNoInfo } from "../../tool/axios"
import { SelectStores } from '../../component/common/Selects'
import getPermission from '../../js/permission'
import moment from 'moment'

import './css/IndexWorkbench.css'

const { Option } = Select
const { Column } = Table

export default function (props: any) {

    const History = useHistory()

    // 页面权限设置
    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    // 当前人员所在的门店
    const [storesList, setStoresList] = useState<any>([])
    // 当前选择的门店信息
    const [curretnStore, setCurretnStore] = useState<any>({
        id: null,
        room_number: null,
        store_id: "",
        store_name: ""
    })

    // 登录角色【current_position_number】的数据，管家：26、营养师：36
    const [loginRole, setLoginRole] = useState<any>(null)
    // 按钮类型
    const btnCurrentRef = useRef<any>(1)

    // 销售门店标识
    const [salesStore, setSalesStore] = useState<any>(null)

    // 数据汇总
    const [summary, setSummary] = useState<any>({
        wait_room_num: 0, // 待排房数量
        wait_meal_num: 0, // 待排餐数量
        tomorrow_wait_order_num: 0, // 明日待下单数量
        todays_check_in_num: 0, // 今日入住数量
        tomorrow_check_in_num: 0, // 明日入住数量
        todays_check_out_num: 0, // 今日出所数量
        leave_three_days_num: 0, // 3天内出所数量
    })

    const resetForm = () => {
        fetchTableData()
        setSalesStore('')
    }

    // 表格数据
    const [dataOne, setDataOne] = useState<any>([])
    const [loadingOne, setLoadingOne] = useState<any>(false)

    const [dataTwo, setDataTwo] = useState<any>([])
    const [loadingTwo, setLoadingTwo] = useState<any>(false)

    const [dataThree, setDataThree] = useState<any>([])
    const [loadingThree, setLoadingThree] = useState<any>(false)

    useEffect(() => {
        if (localStorage.getItem('userData')) {
            let result: any = localStorage.getItem('userData')
            let loginRoleInfo: any = JSON.parse(result)

            setLoginRole(loginRoleInfo)

            // 若是 管家、营养师，才请求汇总数据。否则，直接获取所有门店数据
            if (loginRoleInfo.current_position_number == 26 || loginRoleInfo.current_position_number == 36) {
                fetchStoreData()

            } else {
                // 获取门店数据
                fetchTableData()
            }

        } else {
            setLoginRole(null)
        }
    }, [])

    // 获取当前员工所在的门店
    const fetchStoreData = () => {
        baseAxiosNoInfo('/global/store_list_by_employee', {}).then((res: any) => {
            if (res) {
                setStoresList(res)
                // 设置当前选择的门店信息
                setCurretnStore(res[0])

                // 获取汇总数据
                fetchSummary(res[0]['store_id'])
                // 获取门店数据
                fetchTableData()
            }
        })
    }

    // 获取汇总数据
    const fetchSummary = (store_id: any) => {
        baseAxiosNoInfo('/home_page/summary_customer_num', {
            params: {
                store_id
            }

        }).then((res: any) => {
            if (res) {
                setSummary(res)
            }
        })
    }

    // 获取列表数据
    const fetchTableData = (id?: any) => {
        let url: any = '', params: any = {}

        if (btnCurrentRef.current == 1) {
            setLoadingOne(true)
            url = '/home_page/store_data_list'
            params.store_id = ''

        } else if (btnCurrentRef.current == 2) {
            setLoadingTwo(true)
            url = '/home_page/sales_data_list'
            params.store_id = id ? id : ''

        } else if (btnCurrentRef.current == 3) {
            setLoadingThree(true)
            url = '/home_page/channel_data_list'
            params.store_id = ''
        }

        baseAxiosNoInfo(url, { params }).then((res: any) => {
            if (res) {
                if (btnCurrentRef.current == 1) {
                    setLoadingOne(false)
                    setDataOne(res)

                } else if (btnCurrentRef.current == 2) {
                    setLoadingTwo(false)
                    setDataTwo(res)

                } else if (btnCurrentRef.current == 3) {
                    setLoadingThree(false)
                    setDataThree(res)
                }

            } else {
                setLoadingOne(false)
                setLoadingTwo(false)
                setLoadingThree(false)

                setDataOne([])
                setDataTwo([])
                setDataThree([])
            }
        })
    }

    return (
        <>
            {/* 概览 -> 数据工作台 */}

            {/* 页面标题 */}
            <h1> 欢迎登录 兴宝月禧业务中台</h1>

            {/* 页面主体内容 */}
            {/* 数据工作台 -> 搜索框 */}
            {
                (loginRole && (loginRole.current_position_number == 26 || loginRole.current_position_number == 36)) && (
                    <div className="common-top-form index-top-form">
                        <div className="clear">
                            <span>门店：</span>

                            <Select
                                value={curretnStore.store_id}
                                style={{ width: 150, marginRight: 12, marginBottom: 12, backgroundColor: '#ffffff !important' }}
                                onChange={(v: any) => {
                                    storesList.forEach((storeItem: any) => {
                                        if (storeItem.store_id == v) {
                                            setCurretnStore(storeItem)
                                        }
                                    })
                                    fetchSummary(v)
                                }}
                            >
                                {
                                    storesList.map((storeItem: any) => {
                                        return <Option value={storeItem.store_id} key={storeItem.store_id}>{storeItem.store_name}</Option>
                                    })
                                }

                            </Select>
                        </div>
                    </div>
                )
            }

            {/* 数据工作台 -> 汇总数量标签 -> 管家 */}
            <div className="common-main" style={{ marginTop: '10px' }}>
                <Row gutter={24} style={{ marginBottom: 20, marginLeft: 0 }} wrap>
                    {
                        (loginRole && loginRole.current_position_number == 26) && (
                            <>
                                <Col
                                    span={2.5}
                                    style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: '10px' }}
                                    onClick={() => {
                                        let storeId = ''

                                        if (curretnStore && curretnStore.store_id) {
                                            storeId = curretnStore.store_id
                                        } else {
                                            storeId = storesList[0]['store_id']
                                        }

                                        History.push({
                                            pathname: '/check_in_manage',
                                            state: {
                                                pagination: {
                                                    current: 1,
                                                    pageSize: 8,
                                                    total: 0,
                                                    showSizeChanger: false
                                                },
                                                fetchOtherParams: {
                                                    store_id: storeId,
                                                    check_in_status: undefined,
                                                    belong_minion_id: undefined,
                                                    check_in_user_name: undefined,
                                                    check_in_phone: undefined,
                                                    room_number: undefined,
                                                    preg_status: undefined,
                                                    expectBornDay: null,
                                                    actuallyBornDay: null,
                                                    checkInDay: null,
                                                    checkOutDay: null,
                                                    has_continue: undefined,
                                                    continue_type: undefined,
                                                    nursing_care_type: undefined,
                                                    dealDate: undefined
                                                },
                                                btnCurrentType: 1,
                                                check_in_store_id: storeId
                                            }
                                        })

                                        window.location.reload()
                                    }}
                                >
                                    <Statistic
                                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>已签单待排房</div>}
                                        value={summary ? summary.wait_room_num : 0} />
                                </Col>

                                <Col
                                    span={2.5}
                                    style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: '10px' }}
                                    onClick={() => {
                                        props.dd('666')
                                        let storeId = ''

                                        if (curretnStore && curretnStore.store_id) {
                                            storeId = curretnStore.store_id
                                        } else {
                                            storeId = storesList[0]['store_id']
                                        }

                                        let dayArr = []
                                        let currentDay = moment().format('YYYY-MM-DD')
                                        dayArr = [currentDay, currentDay]

                                        History.push({
                                            pathname: '/check_in_manage',
                                            state: {
                                                pagination: {
                                                    current: 1,
                                                    pageSize: 8,
                                                    total: 0,
                                                    showSizeChanger: false
                                                },
                                                fetchOtherParams: {
                                                    store_id: storeId,
                                                    check_in_status: undefined,
                                                    belong_minion_id: undefined,
                                                    check_in_user_name: undefined,
                                                    check_in_phone: undefined,
                                                    room_number: undefined,
                                                    preg_status: undefined,
                                                    expectBornDay: null,
                                                    actuallyBornDay: null,
                                                    checkInDay: dayArr,
                                                    checkOutDay: null,
                                                    has_continue: undefined,
                                                    continue_type: undefined,
                                                    nursing_care_type: undefined,
                                                    dealDate: undefined
                                                },
                                                btnCurrentType: 0,
                                                check_in_store_id: storeId
                                            }
                                        })

                                        window.location.reload()
                                    }}
                                >
                                    <Statistic
                                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>预计今日入住</div>}
                                        value={summary ? summary.todays_check_in_num : 0} />
                                </Col>

                                <Col
                                    span={2.5}
                                    style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: '10px' }}
                                    onClick={() => {
                                        let storeId = ''

                                        if (curretnStore && curretnStore.store_id) {
                                            storeId = curretnStore.store_id
                                        } else {
                                            storeId = storesList[0]['store_id']
                                        }

                                        let dayArr = []
                                        let currentDay = moment().add(1, 'd').format('YYYY-MM-DD')
                                        dayArr = [currentDay, currentDay]

                                        History.push({
                                            pathname: '/check_in_manage',
                                            state: {
                                                pagination: {
                                                    current: 1,
                                                    pageSize: 8,
                                                    total: 0,
                                                    showSizeChanger: false
                                                },
                                                fetchOtherParams: {
                                                    store_id: storeId,
                                                    check_in_status: undefined,
                                                    belong_minion_id: undefined,
                                                    check_in_user_name: undefined,
                                                    check_in_phone: undefined,
                                                    room_number: undefined,
                                                    preg_status: undefined,
                                                    expectBornDay: null,
                                                    actuallyBornDay: null,
                                                    checkInDay: dayArr,
                                                    checkOutDay: null,
                                                    has_continue: undefined,
                                                    continue_type: undefined,
                                                    nursing_care_type: undefined,
                                                    dealDate: undefined
                                                },
                                                btnCurrentType: 0,
                                                check_in_store_id: storeId
                                            }
                                        })

                                        window.location.reload()
                                    }}
                                >
                                    <Statistic
                                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>预计明日入住</div>}
                                        value={summary ? summary.tomorrow_check_in_num : 0} />
                                </Col>

                                <Col
                                    span={2.5}
                                    style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: '10px' }}
                                    onClick={() => {
                                        let storeId = ''

                                        if (curretnStore && curretnStore.store_id) {
                                            storeId = curretnStore.store_id
                                        } else {
                                            storeId = storesList[0]['store_id']
                                        }

                                        let dayArr = []
                                        let currentDay = moment().format('YYYY-MM-DD')
                                        dayArr = [currentDay, currentDay]

                                        History.push({
                                            pathname: '/check_in_manage',
                                            state: {
                                                pagination: {
                                                    current: 1,
                                                    pageSize: 8,
                                                    total: 0,
                                                    showSizeChanger: false
                                                },
                                                fetchOtherParams: {
                                                    store_id: storeId,
                                                    check_in_status: undefined,
                                                    belong_minion_id: undefined,
                                                    check_in_user_name: undefined,
                                                    check_in_phone: undefined,
                                                    room_number: undefined,
                                                    preg_status: undefined,
                                                    expectBornDay: null,
                                                    actuallyBornDay: null,
                                                    checkInDay: undefined,
                                                    checkOutDay: dayArr,
                                                    has_continue: undefined,
                                                    continue_type: undefined,
                                                    nursing_care_type: undefined,
                                                    dealDate: undefined
                                                },
                                                btnCurrentType: 0,
                                                check_in_store_id: storeId
                                            }
                                        })

                                        window.location.reload()
                                    }}
                                >
                                    <Statistic
                                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>预计今日出所</div>}
                                        value={summary ? summary.todays_check_out_num : 0} />
                                </Col>

                                <Col
                                    span={2.5}
                                    style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: '10px' }}
                                    onClick={() => {
                                        let storeId = ''

                                        if (curretnStore && curretnStore.store_id) {
                                            storeId = curretnStore.store_id
                                        } else {
                                            storeId = storesList[0]['store_id']
                                        }

                                        let dayArr = []
                                        let currentDay = moment().format('YYYY-MM-DD')
                                        let threeDay = moment().add(3, 'd').format('YYYY-MM-DD')

                                        dayArr = [currentDay, threeDay]
                                        console.log(dayArr)

                                        History.push({
                                            pathname: '/check_in_manage',
                                            state: {
                                                pagination: {
                                                    current: 1,
                                                    pageSize: 8,
                                                    total: 0,
                                                    showSizeChanger: false
                                                },
                                                fetchOtherParams: {
                                                    store_id: storeId,
                                                    check_in_status: undefined,
                                                    belong_minion_id: undefined,
                                                    check_in_user_name: undefined,
                                                    check_in_phone: undefined,
                                                    room_number: undefined,
                                                    preg_status: undefined,
                                                    expectBornDay: null,
                                                    actuallyBornDay: null,
                                                    checkInDay: null,
                                                    checkOutDay: dayArr,
                                                    has_continue: undefined,
                                                    continue_type: undefined,
                                                    nursing_care_type: undefined,
                                                    dealDate: undefined
                                                },
                                                btnCurrentType: 7,
                                                check_in_store_id: storeId
                                            }
                                        })

                                        window.location.reload()
                                    }}
                                >
                                    <Statistic
                                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>预计3天内出所</div>}
                                        value={summary ? summary.leave_three_days_num : 0} />
                                </Col>
                            </>
                        )
                    }

                    {/* 数据工作台 -> 汇总数量标签 -> 营养师 */}
                    {
                        (loginRole && loginRole.current_position_number == 36) && (
                            <>
                                <Col
                                    span={2.5}
                                    style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: '10px' }}
                                    onClick={() => {
                                        let storeId = ''

                                        if (curretnStore && curretnStore.store_id) {
                                            storeId = curretnStore.store_id
                                        } else {
                                            storeId = storesList[0]['store_id']
                                        }

                                        History.push({
                                            pathname: '/food_check_in_manage',
                                            state: {
                                                pagination: {
                                                    current: 1,
                                                    pageSize: 8,
                                                    total: 0,
                                                    showSizeChanger: false
                                                },
                                                fetchOtherParams: {
                                                    tomorrow_food_plan_status: 0,
                                                    actually_born_month: undefined,
                                                    expect_born_month: undefined,
                                                    belong_dietician_id: undefined,
                                                    store_id: storeId,
                                                    check_in_status: undefined,
                                                    belong_minion_id: undefined,
                                                    check_in_user_name: undefined,
                                                    check_in_phone: undefined,
                                                    room_number: undefined,
                                                    preg_status: undefined,
                                                    checkInDay: undefined,
                                                    checkOutDay: undefined,
                                                    has_continue: undefined,
                                                    continue_type: undefined
                                                }
                                            }
                                        })

                                        window.location.reload()
                                    }}
                                >
                                    <Statistic
                                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>已排房待排餐</div>}
                                        value={summary ? summary.wait_meal_num : 0} />
                                </Col>

                                <Col
                                    span={2.5}
                                    style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: '10px' }}
                                    onClick={() => {
                                        let storeId = ''

                                        if (curretnStore && curretnStore.store_id) {
                                            storeId = curretnStore.store_id
                                        } else {
                                            storeId = storesList[0]['store_id']
                                        }

                                        let dayArr = []
                                        let currentDay = moment().add(1, 'd').format('YYYY-MM-DD')
                                        dayArr = [currentDay, currentDay]

                                        History.push({
                                            pathname: '/food_check_in_manage',
                                            state: {
                                                pagination: {
                                                    current: 1,
                                                    pageSize: 8,
                                                    total: 0,
                                                    showSizeChanger: false
                                                },
                                                fetchOtherParams: {
                                                    tomorrow_food_plan_status: undefined,
                                                    actually_born_month: undefined,
                                                    expect_born_month: undefined,
                                                    belong_dietician_id: undefined,
                                                    store_id: storeId,
                                                    check_in_status: undefined,
                                                    belong_minion_id: undefined,
                                                    check_in_user_name: undefined,
                                                    check_in_phone: undefined,
                                                    room_number: undefined,
                                                    preg_status: undefined,
                                                    checkInDay: dayArr,
                                                    checkOutDay: undefined,
                                                    has_continue: undefined,
                                                    continue_type: undefined
                                                }
                                            }
                                        })

                                        window.location.reload()
                                    }}
                                >
                                    <Statistic
                                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>预计明日入住</div>}
                                        value={summary ? summary.tomorrow_check_in_num : 0} />
                                </Col>

                                <Col
                                    span={2.5}
                                    style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: '10px' }}
                                    onClick={() => {
                                        let storeId = ''

                                        if (curretnStore && curretnStore.store_id) {
                                            storeId = curretnStore.store_id
                                        } else {
                                            storeId = storesList[0]['store_id']
                                        }

                                        History.push({
                                            pathname: '/food_check_in_manage',
                                            state: {
                                                pagination: {
                                                    current: 1,
                                                    pageSize: 8,
                                                    total: 0,
                                                    showSizeChanger: false
                                                },
                                                fetchOtherParams: {
                                                    tomorrow_food_plan_status: 1,
                                                    actually_born_month: undefined,
                                                    expect_born_month: undefined,
                                                    belong_dietician_id: undefined,
                                                    store_id: storeId,
                                                    check_in_status: undefined,
                                                    belong_minion_id: undefined,
                                                    check_in_user_name: undefined,
                                                    check_in_phone: undefined,
                                                    room_number: undefined,
                                                    preg_status: undefined,
                                                    checkInDay: undefined,
                                                    checkOutDay: undefined,
                                                    has_continue: undefined,
                                                    continue_type: undefined
                                                }
                                            }
                                        })

                                        window.location.reload()
                                    }}
                                >
                                    <Statistic
                                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>明日待下单</div>}
                                        value={summary ? summary.tomorrow_wait_order_num : 0} />
                                </Col>

                                <Col
                                    span={2.5}
                                    style={{ background: '#cce1f4', marginRight: '10px', borderRadius: '10px', marginTop: '10px' }}
                                    onClick={() => {
                                        let storeId = ''

                                        if (curretnStore && curretnStore.store_id) {
                                            storeId = curretnStore.store_id
                                        } else {
                                            storeId = storesList[0]['store_id']
                                        }

                                        let dayArr = []
                                        let currentDay = moment().format('YYYY-MM-DD')
                                        let threeDay = moment().add(3, 'd').format('YYYY-MM-DD')
                                        dayArr = [currentDay, threeDay]

                                        History.push({
                                            pathname: '/food_check_in_manage',
                                            state: {
                                                pagination: {
                                                    current: 1,
                                                    pageSize: 8,
                                                    total: 0,
                                                    showSizeChanger: false
                                                },
                                                fetchOtherParams: {
                                                    tomorrow_food_plan_status: undefined,
                                                    actually_born_month: undefined,
                                                    expect_born_month: undefined,
                                                    belong_dietician_id: undefined,
                                                    store_id: storeId,
                                                    check_in_status: undefined,
                                                    belong_minion_id: undefined,
                                                    check_in_user_name: undefined,
                                                    check_in_phone: undefined,
                                                    room_number: undefined,
                                                    preg_status: undefined,
                                                    checkInDay: undefined,
                                                    checkOutDay: dayArr,
                                                    has_continue: undefined,
                                                    continue_type: undefined
                                                }
                                            }
                                        })

                                        window.location.reload()
                                    }}
                                >
                                    <Statistic
                                        title={<div style={{ fontSize: '16px', fontWeight: 'bold' }}>预计3天内出所</div>}
                                        value={summary ? summary.leave_three_days_num : 0} />
                                </Col>
                            </>
                        )
                    }
                </Row>
            </div>

            {/* 数据工作台 -> 汇总数据表格 -> 数据按钮 */}
            <div className="common-main">
                <div className="search-btn">
                    <Space direction="horizontal" wrap>
                        <Button
                            size="large"
                            type={btnCurrentRef.current == 1 ? 'primary' : 'default'}
                            style={{ marginRight: "20px" }}
                            onClick={() => {
                                btnCurrentRef.current = 1
                                fetchTableData()
                                setSalesStore('')
                            }} >
                            门店数据
                        </Button>

                        <Button
                            size="large"
                            type={btnCurrentRef.current == 2 ? 'primary' : 'default'}
                            style={{ marginRight: "20px" }}
                            onClick={() => {
                                btnCurrentRef.current = 2
                                fetchTableData()
                                setSalesStore('')
                            }} >
                            销售数据
                        </Button>

                        <Button
                            size="large"
                            type={btnCurrentRef.current == 3 ? 'primary' : 'default'}
                            style={{ marginRight: "20px" }}
                            onClick={() => {
                                btnCurrentRef.current = 3
                                fetchTableData()
                                setSalesStore('')
                            }} >
                            渠道数据
                        </Button>
                    </Space>
                </div>

                {/* 数据工作台 -> 汇总数据表格 -> 门店数据 */}
                {
                    btnCurrentRef.current == 1 && (
                        <Table
                            rowKey="store_name"
                            loading={loadingOne}
                            dataSource={dataOne}
                            scroll={{ x: 'max-content' }}
                            bordered={true}
                            pagination={false}
                        >
                            <Column title="门店名称" dataIndex="store_name" key="store_name" />
                            <Column title="昨日合同总金额" dataIndex="yestedays_agreement_amount" key="yestedays_agreement_amount" />
                            <Column title="本周合同总金额" dataIndex="week_agreement_amount" key="week_agreement_amount" />
                            <Column title="当月合同目标" dataIndex="month_agreement_target" key="month_agreement_target" />
                            <Column title="当月合同完成率" dataIndex="month_agreement_finish_per" key="month_agreement_finish_per" />
                            <Column title="当月合同总金额" dataIndex="month_agreement_amount" key="month_agreement_amount" />
                            <Column title="当月客单价" dataIndex="month_guest_price" key="month_guest_price" />
                            <Column title="当月实收金额" dataIndex="month_paid_amount" key="month_paid_amount" />
                            <Column title="当月新增入住人数" dataIndex="month_check_in_num" key="month_check_in_num" />
                            <Column title="在住人数" dataIndex="check_in_num" key="check_in_num" />
                            <Column title="服务人数" dataIndex="service_num" key="service_num" />
                            <Column title="入住率" dataIndex="check_in_per" key="check_in_per" />
                        </Table>
                    )
                }

                {/* 数据工作台 -> 汇总数据表格 -> 销售数据 */}
                {
                    btnCurrentRef.current == 2 && (
                        <div>
                            <div className="index-top-form" style={{ width: 350, marginRight: 12, marginBottom: 12 }}>
                                <span>门店：</span>
                                <SelectStores
                                    value={salesStore}
                                    onChange={(v: string) => {
                                        fetchTableData(v)
                                        setSalesStore(v)
                                    }}
                                />

                                <Button style={{ marginLeft: 12 }} icon={<RedoOutlined />} onClick={resetForm}>重置</Button>
                            </div>

                            <Table
                                rowKey="sales_name"
                                loading={loadingTwo}
                                dataSource={dataTwo}
                                scroll={{ x: 'max-content' }}
                                bordered={true}
                                pagination={false}
                            >
                                <Column title="门店" dataIndex="store_name" key="store_name" />
                                <Column title="销售姓名" dataIndex="sales_name" key="sales_name" />
                                <Column title="当月接收客资数" dataIndex="month_receive_num" key="month_receive_num" />
                                <Column title="当月流失客资数" dataIndex="month_gone_num" key="month_gone_num" />
                                <Column title="当月转化率" dataIndex="month_transfer_per" key="month_transfer_per" />
                                <Column title="昨日合同总金额" dataIndex="yestedays_agreement_amount" key="yestedays_agreement_amount" />
                                <Column title="本周合同总金额" dataIndex="week_agreement_amount" key="week_agreement_amount" />
                                <Column title="当月合同总金额" dataIndex="month_agreement_amount" key="month_agreement_amount" />
                                <Column title="当月签单数" dataIndex="month_deal_num" key="month_deal_num" />
                                <Column title="当月客单价" dataIndex="month_guest_price" key="month_guest_price" />
                                <Column title="当月实收金额" dataIndex="month_paid_amount" key="month_paid_amount" />
                            </Table>
                        </div>
                    )
                }

                {/* 数据工作台 -> 汇总数据表格 -> 渠道数据 */}
                {
                    btnCurrentRef.current == 3 && (
                        <Table
                            rowKey="channel_name"
                            loading={loadingThree}
                            dataSource={dataThree}
                            scroll={{ x: 'max-content' }}
                            bordered={true}
                            pagination={false}
                        >
                            <Column title="渠道名称" dataIndex="channel_name" key="channel_name" />
                            <Column title="当前有效客资" dataIndex="all_customer" key="all_customer" />
                            <Column title="昨日新增客资" dataIndex="yestedays_customer_num" key="yestedays_customer_num" />
                            <Column title="本周新增客资" dataIndex="week_customer_num" key="week_customer_num" />
                            <Column title="当月新增客资" dataIndex="month_customer_num" key="month_customer_num" />
                            <Column title="当月流失客资数" dataIndex="month_gone_num" key="month_gone_num" />
                            <Column title="当月进店人数" dataIndex="visit_store_num" key="visit_store_num" />
                            <Column title="昨日合同总金额" dataIndex="yestedays_agreement_amount" key="yestedays_agreement_amount" />
                            <Column title="本周合同总金额" dataIndex="week_agreement_amount" key="week_agreement_amount" />
                            <Column title="当月合同总金额" dataIndex="month_agreement_amount" key="month_agreement_amount" />
                            <Column title="当月签单数" dataIndex="month_deal_num" key="month_deal_num" />
                            <Column title="当月客单价" dataIndex="month_guest_price" key="month_guest_price" />
                        </Table>
                    )
                }
            </div>
        </>
    )
}